









import DesignTrain from "@/components/products/railway/design/DesignTrain.vue"
import RailwayPlaceholder from "@/components/products/railway/design/RailwayPlaceholder.vue"
import RailwayBox from "@/components/products/railway/design/RailwayBox.vue"
import StickerEdit from "@/components/products/railway/design/StickerEdit.vue"
import { RailwayModule } from '@/store/modules/railway'
import { AppModule } from '@/store/modules/app'
import CartButton from "@/components/products/railway/util/CartButton.vue"

export default {
    name: "railway-design",

    components: {
        DesignTrain,
        StickerEdit,
        CartButton,
        RailwayPlaceholder,
        RailwayBox
    },
    computed: {
        showDesignTrain: function () {
            return RailwayModule.showDesignTrain || (AppModule.showMenu && !RailwayModule.designStickerChanged && !AppModule.isClean)
        },
        showSticker: function() {
            return (RailwayModule.showImageUpload || RailwayModule.showDedication)
        },
        showPlaceholder: function() {
            return AppModule.showMenu && AppModule.isClean
        },
        showBox3D: function() {
            return RailwayModule.showBox3D
        }
    }
}
